import { Text, Tooltip } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { currency } from "@src/utils/formatters";

type Props = {
  balance_amount: number;
  expenses_amount: number;
  invoiced_amount: number;
};
export const ProfitAndLossBalance = ({
  balance_amount,
  expenses_amount,
  invoiced_amount,
}: Props) => {
  return (
    <Tooltip
      label={
        <Text>
          <strong>
            <Trans>Expenses amount</Trans>
          </strong>
          <br />
          {currency.formatByWorkspace(expenses_amount)}
          <br />
          <br />
          <strong>
            <Trans>Invoiced amount</Trans>
          </strong>
          <br />
          {currency.formatByWorkspace(invoiced_amount)}
        </Text>
      }
      shouldWrapChildren
    >
      <Text
        color={balance_amount < 0 ? "red.500" : undefined}
        fontWeight="medium"
      >
        {currency.formatByWorkspace(balance_amount)}
      </Text>
    </Tooltip>
  );
};
